import { useRedirect, useRecordContext } from 'react-admin';
import { Link } from '@mui/material';

export const ContactNameLink = ({ sourceFirst = 'firstName', sourceLast = 'lastName' }: { sourceFirst?: string; sourceLast?: string }) => {
  const record = useRecordContext();
  const redirect = useRedirect();

  if (!record?.contactId) return null;

  const name = `${record[sourceFirst] ?? ''} ${record[sourceLast] ?? ''}`.trim() || '-';

  return (
    <Link
      underline="hover"
      onClick={(e) => {
        e.stopPropagation();
        redirect('show', 'contacts', record.contactId);
      }}
      sx={{ cursor: 'pointer' }}
    >
      {name}
    </Link>
  );
};
